import React, { useCallback, useMemo } from 'react';
import { MapView } from '@agissc/ktag-map';
import debounce from 'lodash.debounce';
import useAppState from '../../AppStore';

const resolutions = [500, 250, 100, 50, 20, 10, 5, 2.5, 2, 1.5, 1, 0.5, 0.25, 0.1];

const ViewControl = () => {
  const setLocation = useAppState((state) => state.setLocation);
  const setMouseLocation = useAppState((state) => state.setMouseLocation);
  const location = useAppState((state) => state.location);
  const navigationIsEnabled = useAppState((state) => state.navigationIsEnabled);
  const isLoggedIn = useAppState((state) => state.isLoggedIn);

  const zoomOptions = useMemo(
    () => ({
      resolutions: isLoggedIn ? [...resolutions, 0.05] : [...resolutions],
      nearest: false,
      duration: 250,
      disabled: !navigationIsEnabled,
    }),
    [isLoggedIn, navigationIsEnabled],
  );

  const debounceSetLocation = useCallback(debounce(setLocation, 300), [setLocation]);

  return (
    <MapView
      location={location}
      onLocationChanged={debounceSetLocation}
      zoomOptions={zoomOptions}
      onMouseLocationChanged={setMouseLocation}
    />
  );
};

export default ViewControl;
